import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { initSentry } from './lib/sentryInit.js';
import { markChunkRecoverySuccess } from './lib/lazyWithRetry.js';
import App from './App.jsx';
import './styles/tokens.css';
import './styles/global.css';

// MUST come before render so boot-time errors get captured too.
initSentry();

// Clear the stale-chunk reload flag now that we've successfully loaded the
// new build. Without this, a single transient network failure during a
// later lazy import would rethrow instead of triggering the reload-recovery
// (because the flag from a prior session would still be set).
markChunkRecoverySuccess();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
